var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.namespaceClass()},[_c('mds-checkbox',{class:_vm.namespaceClass('__header'),attrs:{"checked":_vm.checked,"disabled":_vm.disabled},on:{"change":_vm.handleReportChecked}},[_vm._v(_vm._s(_vm.text))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }